import { toDateTimeStr } from '@mi-front/core';
import { ModalStateProps } from '@mi-front/ui';
import { useActiveStation } from '../../../../../../core/stations/hooks/useActiveStation';
import { useRangeAuditResults } from '../../../../../logger/screens/stream/components/audit/useRangeAuditResults';
import {
  useClearCursor,
  useCursor,
} from '../../../../../logger/screens/stream/stores/stream-screen.store';
import { MentionsAddPage } from '../../screens/mentions-add/MentionsAddPage';

export function MentionAddFromCursor(p: ModalStateProps) {
  const station = useActiveStation();
  const ts = useCursor();
  const clearCursor = useClearCursor();
  const { reload } = useRangeAuditResults();

  if (!ts) {
    return null;
  }

  return (
    <MentionsAddPage
      station={station}
      datetime={toDateTimeStr(ts)}
      onSuccess={() => {
        reload();
        clearCursor();
      }}
      {...p}
    />
  );
}
